import React, { useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../api/baseurl";
import { Modal, Button } from "react-bootstrap";
import "./Spinner.css";
import { useNavigate } from "react-router";
import "./hm-theme.css";

const UploadLocationsCsvFile = ({ isOpen, onRequestClose, companycode, companyId }) => {
  const token = JSON.parse(localStorage.getItem("data"))?.token;
  const [loading, setLoading] = useState(false);
  const [csvFile, setCsvFile] = useState(null);

  const url = "/api/geolocation/upload";
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!csvFile) {
      toast.error("Please choose a CSV file to upload");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("file", csvFile);
    formData.append("companyId", companyId);

    try {
      await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setLoading(false);
      toast.success("Locations CSV uploaded successfully!");
      onRequestClose();
      setCsvFile(null);
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  const handleCsvFileChange = (e) => {
    const file = e.target.files[0];
    setCsvFile(file);
  };

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered className="hm-modal">
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">cloud_upload</i>
          Upload Locations CSV
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <form onSubmit={handleSubmit}>
          {companycode && (
            <div className="mb-3">
              <label htmlFor="companyCode" className="form-label small fw-semibold">Company Code</label>
              <input
                className="form-control bg-light"
                id="companyCode"
                type="text"
                value={companycode}
                readOnly
              />
            </div>
          )}

          <div className="mb-4">
            <label className="form-label small fw-semibold">Select CSV File <span className="text-danger">*</span></label>
            <div className="border border-2 border-dashed rounded-3 p-4 text-center bg-light">
              <i className="material-icons text-primary mb-2" style={{ fontSize: "2rem" }}>upload_file</i>
              <p className="small text-muted mb-2">Choose a CSV file containing location records</p>
              <input
                className="form-control form-control-sm w-75 mx-auto"
                id="file"
                type="file"
                accept=".csv"
                onChange={handleCsvFileChange}
                required
              />
              {csvFile && (
                <div className="mt-2 text-success small fw-semibold">
                  <i className="material-icons align-middle me-1" style={{ fontSize: "16px" }}>check_circle</i>
                  Selected: {csvFile.name}
                </div>
              )}
            </div>
          </div>

          <div className="d-flex justify-content-end gap-2 pt-2">
            <Button variant="secondary" className="rounded-pill px-4" onClick={onRequestClose} disabled={loading}>
              Cancel
            </Button>
            <button type="submit" className="btn-hm-primary" disabled={loading || !csvFile}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>file_upload</i>
              Upload CSV
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default UploadLocationsCsvFile;

